// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__Vpm1A","footer":"ModalFilter_footer__2UpQ0"};